import { render, staticRenderFns } from "./market-item-orders.vue?vue&type=template&id=2ebec0fd&scoped=true"
import script from "./market-item-orders.vue?vue&type=script&lang=js"
export * from "./market-item-orders.vue?vue&type=script&lang=js"
import style0 from "./market-item-orders.vue?vue&type=style&index=0&id=2ebec0fd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebec0fd",
  null
  
)

export default component.exports